module.exports = __webpack_public_path__ + "img/package-slide-2.99320b8b.png";